import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
export type OpsOrderDetailFragment = { __typename?: 'OpsOrderDetail', id: string, type?: Types.MerchantOrderTypeEnum | null, system: string, status: Types.MerchantOrderStatusEnum, store_name?: string | null, store_text_id?: string | null, city?: string | null, country?: string | null, created_at: string, health: string, carrier?: Types.OpsOrderCarrier | null, last_updated: string, warehouse?: string | null, warehouse_uuid?: string | null, warehouse_is_automatic: boolean, item_location?: string | null, delivery_date?: string | null, package_count: number, package_weights: Array<number>, carrier_service?: Types.OpsOrderCarrierService | null, language?: string | null, order_execution_date?: string | null, carrier_pickup_date?: string | null, comment?: string | null, ops_comment?: string | null, event_start_date?: string | null, event_end_date?: string | null, event_manager?: string | null, target_store_user_id?: string | null, error_type?: Types.MerchantOrderErrorTypeEnum | null, order_form_id?: string | null, order_form_deadline?: string | null, error_message?: string | null, container_types_used_detail: Array<{ __typename?: 'ContainerType', id: number, name: string, image_url?: string | null, image?: string | null, packing_unit?: number | null, color_hex_code?: string | null, segment?: Types.ContainerTypeSegment | null, size_helper?: string | null }>, created_by?: { __typename?: 'IdName', id: string, name: string } | null, containers: Array<{ __typename?: 'OpsOrderContainer', amount: number, disabled: boolean, disabled_until?: string | null, id: string, item_location_id?: string | null, item_location_name?: string | null, sales_order_url?: string | null, type: { __typename?: 'OpsOrderContainerType', box_count: number, id: number, image_url?: string | null, name?: string | null, packing_unit: number, purchase_price_cents?: number | null } }>, untracked_items: Array<{ __typename?: 'OpsOrderUntrackedItem', id: string, amount: number, item_location_id?: string | null, item_location_name?: string | null, name?: string | null, type: { __typename?: 'OpsOrderUntrackedItemType', id: number, name?: string | null, image_url?: string | null } }>, items: Array<{ __typename?: 'OpsOrderItem', id: string, amount: number, item_location_id?: string | null, item_location_name?: string | null, name?: string | null, item_type: { __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null } }>, delivery_address?: { __typename?: 'DeliveryAddressInfo', additional_info?: string | null, city?: string | null, company?: string | null, country?: string | null, email?: string | null, first_name?: string | null, id: string, last_name?: string | null, name?: string | null, phone_number?: string | null, streetname?: string | null, streetno?: string | null, zip?: string | null } | null, available_carrier_services: Array<{ __typename?: 'AvailableCarrierService', carrier: Types.OpsOrderCarrier, services: Array<Types.OpsOrderCarrierService> }>, carrier_validation_rules: Array<{ __typename?: 'OpsOrderCarrierValidationRules', carrier: Types.OpsOrderCarrier, validation_rules: { __typename?: 'OpsOrderValidationRules', name: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, company: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, streetname: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, additional_info: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, city: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, zip: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, phone_number: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, email: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, country: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport } } }>, status_history: Array<{ __typename?: 'OpsOrderStatusHistory', changed_by?: string | null, comment?: string | null, status: Types.MerchantOrderStatusEnum, timestamp: string }>, carrier_status: Array<{ __typename?: 'OpsOrderCarrierStatus', status?: string | null, status_details?: string | null, tracking_code: string, updated_at?: string | null, shipment_attempt_number?: number | null, is_superseded: boolean, parcel_id?: string | null, is_replacement: boolean }>, validation_rules: { __typename?: 'OpsOrderValidationRules', name: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, company: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, streetname: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, additional_info: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, city: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, zip: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, phone_number: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, email: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport }, country: { __typename?: 'ValidationRule', max?: number | null, min?: number | null, regex?: string | null, support: Types.ValidationSupport } }, internal_transactions: Array<{ __typename?: 'OpsOrderInternalTransaction', amount?: string | null, created_at?: string | null, description?: string | null, id: string, type?: string | null }>, event_ordered_totals?: { __typename?: 'EventOrderedTotals', container_types: Array<{ __typename?: 'EventOrderedContainerTotal', ordered: number, type: { __typename?: 'OpsOrderContainerType', id: number, name?: string | null, image_url?: string | null } }>, item_types: Array<{ __typename?: 'EventOrderedItemTotal', ordered: number, type: { __typename?: 'OpsOrderUntrackedItemType', id: number, name?: string | null, image_url?: string | null } }> } | null, picking_job?: { __typename?: 'OpsOrderPickingJobLink', id: string, status: Types.PickingJobStatus, carrier_pickup_date?: string | null, total_amount_ordered: number, total_amount_picked: number, resolution?: { __typename?: 'PickingJobResolution', destination: Types.PickingJobResolutionDestination, resolved_at: string, reason: string, resolved_by?: { __typename?: 'IdName', id: string, name: string } | null } | null } | null };

export const OpsOrderDetailFragmentDoc = gql`
    fragment OpsOrderDetail on OpsOrderDetail {
  id
  type
  system
  container_types_used_detail: container_types_used {
    id
    name
    image_url
    image
    packing_unit
    color_hex_code
    segment
    size_helper
  }
  status
  store_name
  store_text_id
  city
  country
  created_at
  health
  carrier
  last_updated
  created_by {
    id
    name
  }
  warehouse
  warehouse_uuid
  warehouse_is_automatic
  item_location
  delivery_date
  containers {
    amount
    disabled
    disabled_until
    id
    item_location_id
    item_location_name
    sales_order_url
    type {
      box_count
      id
      image_url
      name
      packing_unit
      purchase_price_cents
    }
  }
  untracked_items {
    id
    amount
    item_location_id
    item_location_name
    name
    type {
      id
      name
      image_url
    }
  }
  items {
    id
    amount
    item_location_id
    item_location_name
    name
    item_type {
      id
      name
      image_url
      color_hex_code
    }
  }
  package_count
  package_weights
  delivery_address {
    additional_info
    city
    company
    country
    email
    first_name
    id
    last_name
    name
    phone_number
    streetname
    streetno
    zip
  }
  carrier_service
  available_carrier_services {
    carrier
    services
  }
  carrier_validation_rules {
    carrier
    validation_rules {
      name {
        max
        min
        regex
        support
      }
      company {
        max
        min
        regex
        support
      }
      streetname {
        max
        min
        regex
        support
      }
      additional_info {
        max
        min
        regex
        support
      }
      city {
        max
        min
        regex
        support
      }
      zip {
        max
        min
        regex
        support
      }
      phone_number {
        max
        min
        regex
        support
      }
      email {
        max
        min
        regex
        support
      }
      country {
        max
        min
        regex
        support
      }
    }
  }
  language
  type
  order_execution_date
  carrier_pickup_date
  comment
  ops_comment
  status_history {
    changed_by
    comment
    status
    timestamp
  }
  carrier_status {
    status
    status_details
    tracking_code
    updated_at
    shipment_attempt_number
    is_superseded
    parcel_id
    is_replacement
  }
  validation_rules {
    name {
      max
      min
      regex
      support
    }
    company {
      max
      min
      regex
      support
    }
    streetname {
      max
      min
      regex
      support
    }
    additional_info {
      max
      min
      regex
      support
    }
    city {
      max
      min
      regex
      support
    }
    zip {
      max
      min
      regex
      support
    }
    phone_number {
      max
      min
      regex
      support
    }
    email {
      max
      min
      regex
      support
    }
    country {
      max
      min
      regex
      support
    }
  }
  internal_transactions {
    amount
    created_at
    description
    id
    type
  }
  event_start_date
  event_end_date
  event_manager
  target_store_user_id
  error_type
  order_form_id
  order_form_deadline
  error_message
  event_ordered_totals {
    container_types {
      type {
        id
        name
        image_url
      }
      ordered
    }
    item_types {
      type {
        id
        name
        image_url
      }
      ordered
    }
  }
  picking_job {
    id
    status
    carrier_pickup_date
    total_amount_ordered
    total_amount_picked
    resolution {
      destination
      resolved_at
      resolved_by {
        id
        name
      }
      reason
    }
  }
}
    `;